import React, { useState } from "react";
import styled from "styled-components";
import { Input, P } from "notes";
import { DonationModal } from "./DonationModal";
import { PaymentForm } from "./PaymentForm";

export const Donation = ({ logo, cta, donationAmount, donateButtonText }) => {
  const [value, setValue] = useState(donationAmount);
  const [modal, setModal] = useState({ open: false });
  const handleSubmit = () => {
    let dollarValue = (parseFloat(value) || 0) * 100;
    setModal({ open: true, value: dollarValue });
  };
  return (
    <>
      <DonationWrapper>
        <OrganizationLogo>
          <Logo src={logo} />
        </OrganizationLogo>
        <DonationBox>
          <CTA>{cta}</CTA>
          <DonationForm>
            <StyledInput
              leftIcon={<DollarSign>$</DollarSign>}
              value={value}
              onChange={setValue}
              type="tel"
            />
            <DonateButton onClick={handleSubmit}>
              {donateButtonText}
            </DonateButton>
          </DonationForm>
        </DonationBox>
      </DonationWrapper>
      {modal.open && (
        <DonationModal open={modal.open} setOpen={setModal}>
          <PaymentForm
            amount={modal.value}
            onComplete={() => setModal({ open: false })}
          />
        </DonationModal>
      )}
    </>
  );
};

const DollarSign = styled(P)`
  color: #707070;
  margin: 3px 0 0 0;
`;

const StyledInput = styled(Input)`
  border-radius: 0;
  border: none;
  color: #707070;
  display: flex;
  align-items: center;
  height: 52px;
  padding: 25px 20px 25px 40px;
  text-align: right;
  max-width: 192px;
  min-width: 110px;
`;

const DonationWrapper = styled.div`
  display: flex;
  padding: 15px;
`;

const OrganizationLogo = styled.div`
  background-color: #ffffff;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: 10px 25px;
  }
  @media only screen and ${(props) => props.theme.media.small} {
    display: none;
  }
`;

const Logo = styled.img`
  width: 100%;
  max-width: 100px;
  display: block;
`;

const DonationBox = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #4580dd;
  color: #ffffff;
  padding: 25px;
  flex: 1;
  @media only screen and (min-width: 1125px) {
    flex-direction: row;
    justify-content: space-between;
  }
  @media only screen and ${(props) => props.theme.media.small} {
    padding: 12px;
  }
`;

const CTA = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 12px;
  @media only screen and (min-width: 1125px) {
    margin-bottom: 0;
    margin-right: 8px;
  }
`;

const DonationForm = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  & > div {
    border-radius: 0;
    flex-grow: 0;
  }
`;

const DonateButton = styled.button`
  display: flex;
  align-items: center;
  background: #ffffff;
  border: none;
  color: #707070;
  cursor: pointer;
  height: 52px;
  padding: 0 28px;
  margin-left: 21px;
  text-transform: uppercase;
`;
